<template id="page">
    <section>
        <div class="row" v-for="r of rows" v-bind:key="r">
            <div v-for="c of rowColMap[r]" v-bind:key="c" :class="'text-center ml-3 mt-4 '+makeWidth(r, c)">
                <viz :viz="vizDataRowCol[r][c][0]"></viz>

            </div>
        </div>

         <div class="row">
                    <div class="col-md-4 col-lg-4 text-center mt-3 mb-5 ml-3" v-if="r2c1.flag === true">
                        <div class="card">

                            <div class="card-header d-flex justify-content-between">

                                <div class="">{{r2c1.name}} - {{r2c1.y}} vs {{r2c1.x}}</div>
                                <a class="txt-color-white right-padding-50"
                                   @click="commentBox(r2c1)">
                                    <i class="fa fa-lg fa-comments"></i>
                                </a>
                            </div>

                            <div class="card-body">
                                <div id="r2c1" ref="r2c1">
                                    <a class='reset'
                                       @click="r2c1.resetChart()"
                                       style='visibility: hidden;'>reset</a>
                                </div>
                            </div>
                        </div>
                    </div>
        </div>

    </section>
</template>
<script>
import Viz from '@/components/viz'
import _ from 'lodash'
import * as d3 from 'd3'
import * as dc from 'dc'
import * as crossfilter from 'crossfilter'

export default {
        name: "page",
        components: {Viz},
        data: () => ({
            searching: false,
            vizData: [],
            vizDataRowCol: {},
            rows: [],
            rowColMap: {}
        }),
        computed: {},
        created() {
            this.loadSummary()
            this.listenToRouter()
        },
        methods: {
            makeWidth: function (r, c) {
                let v0 = this.vizDataRowCol[r][c][0].vizunitWidthArray
                let defV = ['2', '4', '5']
                let v = v0 && v0.length > 0 ? v0 : defV
                let lg = v[2], md = v[1], sm = v[0]
                return `col-lg-${lg} col-md-${md} col-sm-${sm}`
            },
            dynamicDC: function(){
                            let l1period = this.filterPeriodLevel1
                            let l2period = this.filterPeriodLevel2
                            let alldata = this.allSummaryData
                            let data = l1period !== "" ? alldata.filter(a => a.d4l1_yyyy === l1period) : alldata;

                            if (l2period === "quarterly") {
                                data.forEach(function (a) {
                                    a.qt = a.d4l1_yyyy + '-Q' + a.d4l1_qq;
                                });
                            } else if (l2period === "monthly") {
                                data.forEach(function (a) {
                                    a.qt = a.d4l1_yyyy + '-' + a.d4l1_mm;
                                });
                            } else if (l2period === "weekly") {
                                data.forEach(function (a) {
                                    a.qt = a.d4l1_yyyy + '-' + a.d4l1_ww;
                                });
                            }

                            let alt = crossfilter(data);

                                if (this.r2c1.flag) {
                                    let r2c1 = dc.barChart(this.$refs.r2c1)
                                    let r2c1Dim = alt.dimension(function (a) {
                                        return a.qt
                                    });
                                    //  console.log("the group is:", this.r2c1.group)
                                    let r2c1Group = this.r2c1.group
                                    let r2c1Grp = r2c1Dim.group().reduceSum(function (a) {
                                        return a[r2c1Group.toLowerCase()]
                                    });

                                    r2c1
                                        .width(350)
                                        .height(350)
                                        .dimension(r2c1Dim)
                                        .group(r2c1Grp)
                                        .valueAccessor((a) => {
                                            return (a.value / this.r2c1.div).toFixed(2);
                                        })
                                        .keyAccessor(function (a) {
                                            return a.key
                                        })
                                        .x(d3.scaleBand())
                                        .xUnits(dc.units.ordinal)
                                        .gap(1)
                                        .centerBar(false)
                                        .elasticY(true)
                                        .brushOn(false)
                                        .renderLabel(false)
                                        .renderTitle(true)
                                        .controlsUseVisibility(true)
                                        .title((a) => {
                                            return this.r2c1.y + " " + (a.value / this.r2c1.div).toFixed(2) + " " + this.r2c1.unit;
                                        })
                                        .renderlet(function (d) {
                                            d.selectAll('g.x text')
                                                .attr('transform', 'translate(-15, -30) rotate(-90)')
                                        });

                                    this.r2c1.chartElem = r2c1
                                }

},
            loadSummary: function () {
                console.info('loading summary')
                let menuParam = this.$route.params.menuId
                let submenuParam = this.$route.params.submenuId
                this.$store.dispatch("loadState").then(() => {
                    let allVizData = this.$store.state.fwScreenConfig
                    console.log("All FW Screen config data",allVizData);
                    //let vizData = allVizData.filter(r => r.menuId === menuParam && r.subMenuId === submenuParam)
                    let vizData = allVizData.filter(r => r.menuId === submenuParam)
                    if (vizData.length === 0) {
                        console.error("No vizdata for the screen, hence Blank Screen..fix data", vizData, vizData.length)
                        return
                    }
                    console.log("Visualization Data", vizData, vizData.length)
                    this.menuName = this.$store.state.menuMasterData.filter(m => m.menuId === menuParam).map(m => m.menuName)[0]
                    this.screenName = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam).map(m => m.menuName)[0]
                    this.menusyspk = this.$store.state.menuMasterData.filter(m => m.menuId === menuParam).map(m => m.syspk)[0]

                    console.log("menusyspk",this.menusyspk)

                    //what we'll do is identify the max rows
                    //then for each row identify the max cols
                    let maxRows = _.max(vizData.map(v => v.positionRow)) + 1
                    let rowColMap = {}
                    _.range(1, maxRows).forEach(rowNum => {
                        rowColMap[rowNum] = _.range(1, _.max(vizData.filter(v => v.positionRow === rowNum).map(v => v.positionColumn)) + 1)
                    })

                    this.rows = _.range(1, maxRows)
                    this.rowColMap = rowColMap
                    let vizDataRowCol = {}
                    _.forEach(rowColMap, (colCount, rowNumStr) => {
                        let rowNum = +rowNumStr
                        vizDataRowCol[rowNum] = {}
                        let rowData = vizData.filter(v => v.positionRow === rowNum)
                        rowColMap[rowNum].forEach(colNum => {
                            vizDataRowCol[rowNum][colNum] = rowData.filter(v => v.positionColumn === colNum)
                        })

                    })
                    this.vizDataRowCol = vizDataRowCol
                    //log the event in audi log
                   // this.$commonFn.auditLog(this.menuName, this.screenName, "", "GET", "Success")
                   // this.$commonFn.auditLog(this.menusyspk,submenuParam,this.menuName,this.screenName, "GET", "Success")

                }, err => {
                    console.error("error in getting he viz data", err)
                })
            },
            listenToRouter: function () {
                let $this = this
                this.$router.afterEach(function (from, to) {
                    console.log(`router moved to ${from.path} from ${to.path}, page viz = ${$this.rows.length}`)
                    $this.rows = []
                    setTimeout(() => {
                        $this.loadSummary()
                    }, 300)

                })
            }
        }
    }
</script>